import React, { useEffect, useLayoutEffect, useState } from "react";

// Stage Names
const ABOUT_YOU = "About you";
const CONTACT_DETAILS = "Contact";
const CONFIRM_DETAILS = "Confirm Details";
const PRODUCT = "Product";
const SUCCESS = "Form Completed";
const VERIFICATION = "Verify Identity";

const MAP_PAGE_ID_BY_STAGE = {
  "62870cab8f8136001256167d": ABOUT_YOU,
  "62870cd2bbd0f700231a62b0": CONTACT_DETAILS,
  "62870dfd0fdd5f0012534ef1": PRODUCT,
  "62870de18f813600142a64b9": CONFIRM_DETAILS,
  "62870e19bbd0f70033493ee2": SUCCESS,
  "62870ced0fdd5f00130c647c": VERIFICATION,
};

const ProgressBar = ({ getData }) => {
  const [currentPageId, setCurrentPageId] = useState(null);

  const nextPageFromVerificationWaiting = () => {
    let passed = getData().getFieldValue("aply_verificationPassed");
    if (passed === "YES") {
      getData().navigateToPage("62870dfd0fdd5f0012534ef1");
    }
  };

  useEffect(() => {
    const emitter = getData().getEmitter();
    emitter.on("BeforePageRender", (data) => {
      if (data?.id) setCurrentPageId(data.id);

      // Check if verification passed but still on verify screen
      // When refreshing the page or opening a previously closed submission
      if (data?.id === "62870ced0fdd5f00130c647c")
        nextPageFromVerificationWaiting();
    });

    // Watch for value changed on verificationPassed to change page if it was passed
    emitter.on("ValueChanged", (data) => {
      if (
        data?.fieldID === "632d126b7915ab00733e86e2" && // aply_verificationPassed
        data?.newValue === "YES"
      ) {
        getData().navigateToPage("62870dfd0fdd5f0012534ef1");
      }
    });
  }, []);

  return !MAP_PAGE_ID_BY_STAGE[currentPageId] ? (
    <React.Fragment />
  ) : (
    <div className="custom__progress-bar">
      {Object.keys(MAP_PAGE_ID_BY_STAGE).map((stagePageId) => (
        <Stage
          key={stagePageId}
          stagePageId={stagePageId}
          currentPageId={currentPageId}
        />
      ))}
    </div>
  );
};

const Stage = ({ currentPageId, stagePageId }) => {
  let isActive = currentPageId === stagePageId;
  const stageIdx = Object.keys(MAP_PAGE_ID_BY_STAGE).indexOf(stagePageId);
  const currentPageIdx =
    Object.keys(MAP_PAGE_ID_BY_STAGE).indexOf(currentPageId);
  let isComplete = currentPageIdx > stageIdx;

  // Success page is a special case:
  // It shows as complete when it is active
  if (
    currentPageId === "62870e19bbd0f70033493ee2" &&
    stagePageId === "62870e19bbd0f70033493ee2"
  ) {
    isComplete = true;
    isActive = true;
  }

  return (
    <div className="custom__progress-bar__stage">
      <div className="custom__progress-bar__stage__container--top">
        <div
          className={
            "custom__progress-bar__stage__line" +
            (isActive ? " --active" : "") +
            (isComplete ? " --complete" : "") +
            (stageIdx === 0 ? " --first" : "") +
            (stageIdx === 5 ? " --last" : "")
          }
        />
        <div
          className={
            "custom__progress-bar__stage__circle--large" +
            (isActive ? " --active" : "") +
            (isComplete ? " --complete" : "")
          }
        />
        <div
          className={
            "custom__progress-bar__stage__circle--small" +
            (isActive ? " --active" : "") +
            (isComplete ? " --complete" : "")
          }
        >
          <div
            className={
              "custom__progress-bar__stage__tick" +
              (isComplete ? " --complete" : "")
            }
          >
            &#10003;
          </div>
        </div>
      </div>
      <div className="custom__progress-bar__stage__container--bottom">
        <div
          className={
            "custom__progress-bar__stage__label" +
            (isActive ? " --active" : "") +
            (isComplete ? " --complete" : "")
          }
        >
          {MAP_PAGE_ID_BY_STAGE[stagePageId]}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
